export default __webpack_public_path__ + "static/media/Flexible.969172fa.png";